import { EnumSchema, FromSchema, ZodDate } from '@40seas/entities/common';
import { Currency } from '@40seas/models';
import { z } from 'zod';

export const InvoiceFinancingSchema = z
    .object({
        amount: z.number().gt(0),
        currency: EnumSchema(Currency),
        date: ZodDate.optional(),
        payout: z.string().optional(),
    })
    .strict();

export class InvoiceFinancing extends FromSchema(InvoiceFinancingSchema) {
    amount: number;
    currency: Currency;
    date?: Date;
    payout?: string;
}
